<div class="image-view">

    <img src="{{urlImage}}" class="image" alt="" #map />

</div>
